import { memo, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import { getRemoveCourseAction } from '../actions/course';

import styles from './CourseRow.module.css';

import DataContext from '../context';
import { getCourseColor } from '../utils/courseColor';
import infoIcon from '../images/info.png';
import removeIcon from '../images/cross.png';

// Phase 1.4: Memoize CourseRow to prevent unnecessary re-renders
const CourseRow = memo(({ courseCode }) => {
    const { data, selectedTerm } = useContext(DataContext);
    const dispatch = useDispatch();
    const course = data[courseCode];
    const department = courseCode.substring(0, 4);
    const infoLink = `https://w5.ab.ust.hk/wcq/cgi-bin/${selectedTerm}/subject/${department}#${courseCode}`;

    const handleCourseRemove = useCallback(() => {
        dispatch(getRemoveCourseAction(courseCode));
    }, [courseCode, dispatch]);

    if (!course) return null;

    return (
        <tr className={`color${getCourseColor(courseCode)}`}>
            <td>{courseCode}</td>
            <td>{course.name}</td>
            <td>
                <Tippy content="Details">
                    <a
                        className={styles.iconButton}
                        href={infoLink}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <img alt="Details" className={styles.icon} src={infoIcon} />
                    </a>
                </Tippy>
                &nbsp;&nbsp;
                <Tippy content="Remove">
                    <button
                        type="button"
                        className={styles.iconButton}
                        onClick={handleCourseRemove}
                    >
                        <img alt="Remove" className={styles.icon} src={removeIcon} />
                    </button>
                </Tippy>
            </td>
        </tr>
    );
}, (prevProps, nextProps) => {
    // Custom comparison: only re-render if courseCode changes
    return prevProps.courseCode === nextProps.courseCode;
});

export default CourseRow;
